var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAltersverifizierungIdCardBack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 133,
    viewBox: "0 0 226 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_7563)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.326399,
    d: "M222 0H4C1.79086 0 0 1.79086 0 4V85.5C0 87.7091 1.79086 89.5 4 89.5H222C224.209 89.5 226 87.7091 226 85.5V4C226 1.79086 224.209 0 222 0Z",
    fill: "#061437",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.531 0.0999756H4C1.79086 0.0999756 0 1.89084 0 4.09998V128.9C0 131.109 1.79086 132.9 4 132.9H221.531C223.74 132.9 225.531 131.109 225.531 128.9V4.09998C225.531 1.89084 223.74 0.0999756 221.531 0.0999756Z",
    stroke: "#AAAAAA",
    strokeWidth: 1.6,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.943 83.5H2.05714C0.921014 83.5 0 84.421 0 85.5571V87.4429C0 88.579 0.921014 89.5 2.05714 89.5H223.943C225.079 89.5 226 88.579 226 87.4429V85.5571C226 84.421 225.079 83.5 223.943 83.5Z",
    fill: "#061437",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7857 14.7384H18.1333C16.9972 14.7384 16.0762 15.6594 16.0762 16.7955V18.5689C16.0762 19.7051 16.9972 20.6261 18.1333 20.6261H53.7857C54.9218 20.6261 55.8429 19.7051 55.8429 18.5689V16.7955C55.8429 15.6594 54.9218 14.7384 53.7857 14.7384Z",
    fill: "#061437",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7857 46.7384H18.1333C16.9972 46.7384 16.0762 47.6594 16.0762 48.7955V50.5689C16.0762 51.7051 16.9972 52.6261 18.1333 52.6261H53.7857C54.9218 52.6261 55.8429 51.7051 55.8429 50.5689V48.7955C55.8429 47.6594 54.9218 46.7384 53.7857 46.7384Z",
    fill: "#061437",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.475 14.7384H101.823C100.687 14.7384 99.7656 15.6594 99.7656 16.7955V18.5689C99.7656 19.7051 100.687 20.6261 101.823 20.6261H137.475C138.611 20.6261 139.532 19.7051 139.532 18.5689V16.7955C139.532 15.6594 138.611 14.7384 137.475 14.7384Z",
    fill: "#061437",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.475 46.7384H101.823C100.687 46.7384 99.7656 47.6594 99.7656 48.7955V50.5689C99.7656 51.7051 100.687 52.6261 101.823 52.6261H137.475C138.611 52.6261 139.532 51.7051 139.532 50.5689V48.7955C139.532 47.6594 138.611 46.7384 137.475 46.7384Z",
    fill: "#061437",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M63.5912 25.8596H18.1333C16.9972 25.8596 16.0762 26.7806 16.0762 27.9168V29.6902C16.0762 30.8263 16.9972 31.7473 18.1333 31.7473H63.5912C64.7273 31.7473 65.6483 30.8263 65.6483 29.6902V27.9168C65.6483 26.7806 64.7273 25.8596 63.5912 25.8596Z",
    fill: "#061437",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M63.5912 57.8596H18.1333C16.9972 57.8596 16.0762 58.7806 16.0762 59.9168V61.6902C16.0762 62.8263 16.9972 63.7473 18.1333 63.7473H63.5912C64.7273 63.7473 65.6483 62.8263 65.6483 61.6902V59.9168C65.6483 58.7806 64.7273 57.8596 63.5912 57.8596Z",
    fill: "#061437",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M147.281 25.8596H101.823C100.687 25.8596 99.7656 26.7806 99.7656 27.9168V29.6902C99.7656 30.8263 100.687 31.7473 101.823 31.7473H147.281C148.417 31.7473 149.338 30.8263 149.338 29.6902V27.9168C149.338 26.7806 148.417 25.8596 147.281 25.8596Z",
    fill: "#061437",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M147.281 57.8596H101.823C100.687 57.8596 99.7656 58.7806 99.7656 59.9168V61.6902C99.7656 62.8263 100.687 63.7473 101.823 63.7473H147.281C148.417 63.7473 149.338 62.8263 149.338 61.6902V59.9168C149.338 58.7806 148.417 57.8596 147.281 57.8596Z",
    fill: "#061437",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M188.616 99.2473H13.2305C12.0944 99.2473 11.1733 100.168 11.1733 101.304V103.078C11.1733 104.214 12.0944 105.135 13.2305 105.135H188.616C189.752 105.135 190.673 104.214 190.673 103.078V101.304C190.673 100.168 189.752 99.2473 188.616 99.2473Z",
    fill: "#061437",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M188.616 113.247H13.2305C12.0944 113.247 11.1733 114.168 11.1733 115.304V117.078C11.1733 118.214 12.0944 119.135 13.2305 119.135H188.616C189.752 119.135 190.673 118.214 190.673 117.078V115.304C190.673 114.168 189.752 113.247 188.616 113.247Z",
    fill: "#061437",
    fillOpacity: 0.36
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_7563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226,
    height: 132.9,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAltersverifizierungIdCardBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/altersverifizierung-id-card-back.f305fe5eceee707328e5f23d51f3176e.svg";